import React from "react";
import PropTypes from "prop-types";
import { FaHourglassHalf, FaCheckCircle } from "react-icons/fa";
import DisbursementAction from "./DisbursementAction";

const REASON = {
  trade_loan: "Trade loan — handled by the Payment Accountant.",
  non_hsbc: "Not paid through HSBC — the Payment Accountant pays it outside the Portal, then records it here.",
  setting: "HSBC payments go through the Payment Accountant.",
};

const formatDay = (iso) => {
  const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(iso || "");
  return m ? `${m[3]}/${m[2]}/${m[1]}` : "";
};

/**
 * Top of the request page after BOD approved: the payment is with the Payment
 * Accountant (Processing, with the action) or already recorded (Paid). Same place as
 * "Awaiting signature" while the request is still being signed.
 */
const PaymentProcessingBanner = ({ disbursement, canMarkPaid = false, hsbc = false, onMarkPaid, onOpenBank }) => {
  if (disbursement?.status === "paid") {
    const details = [disbursement.paid_by && `Recorded by ${disbursement.paid_by}`, formatDay(disbursement.paid_at),
      disbursement.reference && `Reference ${disbursement.reference}`].filter(Boolean).join(" · ");
    return (
      <div role="status" className="tw-mb-4 tw-rounded-geist-sm tw-border tw-border-solid tw-border-[#c6ecd0] tw-bg-[#edfaef] tw-px-4 tw-py-2.5 tw-flex tw-items-start tw-gap-2.5">
        <FaCheckCircle className="tw-text-geist-success tw-mt-0.5 tw-shrink-0" size={12} />
        <div className="tw-min-w-0">
          <p className="tw-text-sm tw-font-semibold tw-text-[#1a7f37] tw-mb-0">Paid</p>
          {details && <p className="tw-text-xs tw-text-[#1a7f37] tw-mb-0 tw-mt-0.5">{details}</p>}
          {disbursement.note && <p className="tw-text-xs tw-italic tw-text-geist-fg-2 tw-mb-0 tw-mt-0.5">“{disbursement.note}”</p>}
        </div>
      </div>
    );
  }
  if (disbursement?.status !== "processing") return null;

  const team = (disbursement.team || []).map((m) => m.name || m.email).join(", ");
  return (
    <div role="status" className="tw-mb-4 tw-rounded-geist-sm tw-border tw-border-solid tw-border-[#f7e2c0] tw-bg-[#fff8ee] tw-px-4 tw-py-2.5 tw-flex tw-items-center tw-gap-2.5 tw-flex-wrap">
      <FaHourglassHalf className="tw-text-[#b46a00] tw-shrink-0" size={12} />
      <div className="tw-min-w-0 tw-flex-1">
        <p className="tw-text-sm tw-font-semibold tw-text-[#8a5200] tw-mb-0">Payment processing</p>
        <p className="tw-text-xs tw-text-[#b46a00] tw-mb-0 tw-mt-0.5">
          {REASON[disbursement.reason] || "Handled by the Payment Accountant."}
          {team && <> Payment Accountant: <strong>{team}</strong>.</>}
        </p>
      </div>
      <DisbursementAction className="tw-shrink-0" canMarkPaid={canMarkPaid} onMarkPaid={onMarkPaid} hsbc={hsbc} onOpenBank={onOpenBank} />
    </div>
  );
};

PaymentProcessingBanner.propTypes = {
  disbursement: PropTypes.object,
  canMarkPaid: PropTypes.bool,
  hsbc: PropTypes.bool,
  onMarkPaid: PropTypes.func,
  onOpenBank: PropTypes.func,
};

export default PaymentProcessingBanner;
